import React, { useEffect, useState } from 'react';

import { Button } from '@pkg/components';
import { useAppDispatch } from '@pkg/hooks';

import { Admin, type GenerateLootBoxesRequest, type LootBoxType, type LootBoxTypeId } from '@app/client';
import { apiFactory } from '@app/client/apiFactory/api';
import { addNotification } from '@app/store/actions/notification';

import './_LootBoxMgmt.scss';

interface LootBoxMgmtProps {
    lootBoxTypes: LootBoxType[];
    onSuccess: () => void;
}

const LootBoxMgmt = ({ lootBoxTypes, onSuccess }: LootBoxMgmtProps) => {
    const [lbTypes, setlbTypes] = useState<LootBoxType[]>(lootBoxTypes);
    const [numBoxes, setNumBoxes] = useState<number>(0);
    const [selectedLBT, setSelectedLBT] = useState<LootBoxTypeId>('');
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (lootBoxTypes && lootBoxTypes.length > 0) {
            setlbTypes(lootBoxTypes);
            lootBoxTypes[0].id && setSelectedLBT(lootBoxTypes[0].id); // so that there is an initial value
        } else {
            setlbTypes([]);
        }
    }, [lootBoxTypes]);

    const generateLootBox = () => {
        if (selectedLBT) {
            apiFactory()
                .call(Admin.LootBoxes.generateLootBoxes, {
                    value: {
                        loot_box_type_id: selectedLBT,
                        num_boxes: numBoxes,
                    } as GenerateLootBoxesRequest,
                })
                .then((r) => {
                    if (r.ok) {
                        dispatch(addNotification({ message: 'Generated!', severity: 'success' }));
                        onSuccess();
                    } else {
                        dispatch(
                            addNotification({
                                message: r?.error?.detail || 'Error generating lootbox',
                                severity: 'error',
                            }),
                        );
                    }
                })
                .catch((e) => {
                    dispatch(addNotification({ message: e.error, severity: 'error' }));
                });
        }
    };

    const LBTMeta = () => {
        const selectedLBTObject = lootBoxTypes.find((lbt) => lbt.id === selectedLBT);
        if (selectedLBTObject) {
            return (
                <div>
                    <h4>Prism Case Category Meta</h4>
                    <table className="lb-table small">
                        <tbody>
                            <tr className="row-header type">
                                <td>count</td>
                                <td>min score</td>
                                <td>max score</td>
                            </tr>

                            {selectedLBTObject.config.guarantees.map((g, i) => {
                                return (
                                    <tr key={i + 'g'} className="type">
                                        <td>{g.count}</td>
                                        <td>{g.min_score}</td>
                                        <td>{g.max_score}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <table className="lb-table small">
                        <tbody>
                            <tr className="row-header type">
                                <td>min score</td>
                                <td>max score</td>
                                <td>ipr</td>
                            </tr>
                            {selectedLBTObject.config.weights.map((w, i) => {
                                return (
                                    <tr key={i + 'w'} className="type">
                                        <td>{w.min_score}</td>
                                        <td>{w.max_score}</td>
                                        <td>{w.ipr}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return <div>Please select a Prism Case Type to see its Meta</div>;
        }
    };

    return (
        <div key={lootBoxTypes.length} className="lootbox-list">
            <h3>Generate Prism Case:</h3>
            <div className="generate">
                <div>
                    <label htmlFor="types">Choose a Lootbox type:</label>
                    <select
                        className="lbt-select"
                        name="types"
                        id="types"
                        onChange={(e) => setSelectedLBT(e.target.value)}
                    >
                        {lbTypes.map((lbt, i) => {
                            return (
                                <option key={i} className="lbt-option" value={lbt.id}>
                                    {lbt.name}
                                </option>
                            );
                        })}
                    </select>
                    <label htmlFor="numBoxes">Number of boxes:</label>
                    <input type="number" min={0} onChange={(e) => setNumBoxes(Number(e.target.value))} />
                    <div style={{ width: 80 }}>
                        <Button variant="solid" size="small" onClick={() => generateLootBox()}>
                            Generate!
                        </Button>
                    </div>
                </div>

                <LBTMeta />
            </div>
            <br />
            <br />
        </div>
    );
};

export default LootBoxMgmt;
